import { useEffect } from 'react'
import type { BattleInfo } from '@boss/shared'

const fmtDate = (iso: string) =>
  new Date(iso).toLocaleString(undefined, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })

/** "How to play" popup. Content comes from the API: config text, or a summary built from the rules. */
export function HowTo({ info, onClose }: { info: BattleInfo; onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])
  const { startsAt, endsAt } = info.window
  return (
    <div className="howto-backdrop" onClick={onClose} role="presentation">
      <div className="howto grain" role="dialog" aria-modal="true" aria-labelledby="howto-title" onClick={(e) => e.stopPropagation()}>
        <button className="howto-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id="howto-title">{info.ui.howToTitle}</h2>
        <ol className="howto-lines">
          {info.ui.howTo.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ol>
        {startsAt || endsAt ? (
          <p className="howto-window">
            {startsAt ? (
              <>
                <span>Starts</span> {fmtDate(startsAt)}
              </>
            ) : null}
            {startsAt && endsAt ? <br /> : null}
            {endsAt ? (
              <>
                <span>Ends</span> {fmtDate(endsAt)}
              </>
            ) : null}
          </p>
        ) : null}
        {info.ui.links.gacha ? (
          <a className="battle-join" href={info.ui.links.gacha} target="_blank" rel="noopener">
            {info.ui.joinText} <span aria-hidden="true">→</span>
          </a>
        ) : null}
      </div>
    </div>
  )
}
